// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3atu7","label":"CategoryService_label__3m4RX","location":"CategoryService_location__QuTPG"};